<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="970">
    <v-card>
        <v-card-title>
           <v-icon color="primary" left>mdi-file-plus</v-icon> Supplier 
           <v-spacer/>
           <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
            <v-row>
               <v-col cols="6">
                <v-form
                    ref="form"
                    class="mt-1 pa-1"
                    v-model="valid"
                    lazy-validation
                  >
                   <p style="color: #AC1F62;">Details</p>
                    <v-text-field
                    v-model="supplier.company"
                    label="Company Name"
                    :rules="textRules"
                    dense
                    outlined
                    required
                    ></v-text-field>
                    <v-text-field
                    v-model="supplier.tin"
                    label="TIN"
                    dense
                    outlined
                    ></v-text-field>

                    <v-text-field
                    v-model="supplier.person"
                    label="Contact Person"
                    :rules="textRules"
                    dense
                    outlined
                    required
                    ></v-text-field>
                    
                    <v-text-field
                    v-model="supplier.number"
                    label="Contact No."
                    dense
                    outlined
                    ></v-text-field>

                    <v-text-field
                    v-model="supplier.email"
                    label="Email"
                    dense
                    outlined
                    ></v-text-field>
                     <v-textarea
                    v-model="supplier.address"
                    label="Address"
                    dense
                    outlined
                    ></v-textarea>
                    
                </v-form>
               </v-col>
                <v-col cols="6">
                    <table class="va-table  md-font" style="width: 100%;">
                        <tr>
                            <th class="text-left pa-2" style="background: #f0f0f0;">Description</th>
                             <th class="text-right pa-2" style="background: #f0f0f0;">By Sizes</th>
                        </tr>
                        <tr v-for="(item, index) in discounts" :key="index">
                            <td class="text-left pa-2" style="border-bottom: 1px solid #eee;">{{item.description}}</td>
                              <td class="text-right pa-2" style="border-bottom: 1px solid #eee;">
                                  <template v-for="(size, i) in item.sizes" >
                                  <p :key="i+'s'">{{size.size}} <input class="va-input" @change="saveDiscount(item)" v-model="size.amount"/> </p>
                                  </template>
                              </td>
                        </tr>
                    </table>
                </v-col> 
            </v-row>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small  text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    state: {
        type: String,
        default: "new"
    },
    item: {
      type: Object,
      default: ()=>{}
    }
  },
  data: () => ({
      valid: true,
      textRules: [
        v => !!v || 'Field is required'
      ],
      discounts:[],
      discount:{},
       supplier:{}
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      }
  },
  watch: {
    show(v) {
      if(v){
        if(this.state != 'new') {
        this.supplier=this.item
        this.getDiscounts()
        } else {
           this.supplier={}
        }
      } 
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
          if(this.state == 'new') {
            this.Add()
          } else {
            this.Save()
          }
        }
      },
    emitToParent (action) {
       this.$emit('DialogEvent', {action: action, po:this.po})
    },
    getDiscounts() {
       this.$http.post("supplier/get_discounts", {supplier: this.supplier.id}).then(response => {
                response.data.items !=null?this.discounts=response.data.items:this.discounts=[]
               }).catch(e => {
                console.log(e.data)
            })
    },
    saveDiscount(item) {
      this.$http.post("supplier/update_discount",item).then(response => {
          response.data.status?this.VA_ALERT("success", response.data.message):this.VA_ALERT("error", response.data.message)
          }).catch(e => {
          console.log(e.data)
      })
    },
    Save() {
        this.$http.post("supplier/update", this.supplier).then(response => {
            response.data.status?this.VA_ALERT("success", response.data.message):this.VA_ALERT("error", response.data.message)
           this.$emit('DialogEvent', {action: "close"})
          }).catch(e => {
            console.log(e.data)
        })
    },
    Add() {
        this.$http.post("supplier/add", this.supplier).then(response => {
           this.GET_RESPONSE(response)
           this.$emit('DialogEvent', {action: "close"})
          }).catch(e => {
            console.log(e.data)
        })
    }
  }
}
</script>
